import { isApolloError } from "@apollo/client/errors";
import { isGraphQLErrors, translateGraphQLErrors } from "./graphql-errors";
import {
  AlertMessage,
  ApplicationError,
  isApplicationError,
  newErrorAlertMessage,
} from "@design-system";
import { translateApolloError } from "./apollo-errors";
import { GraphQLError } from "graphql";

export function translateError(
  error: Error | ReadonlyArray<GraphQLError>,
  message?: string
): ApplicationError {
  if (isApplicationError(error)) {
    return error;
  }

  if (isGraphQLErrors(error)) {
    return translateGraphQLErrors(error, message);
  }

  if (isApolloError(error)) {
    return translateApolloError(error);
  }

  return new ApplicationError("UNKNOWN_ERROR", message);
}

export function errorAlertMessageFrom(
  error: Error | ReadonlyArray<GraphQLError>,
  onClose?: () => void
): AlertMessage;
export function errorAlertMessageFrom(
  error: Error | ReadonlyArray<GraphQLError>,
  message?: string,
  onClose?: () => void
): AlertMessage;
export function errorAlertMessageFrom(
  error: Error | ReadonlyArray<GraphQLError>,
  message?: string,
  description?: string,
  onClose?: () => void
): AlertMessage;
export function errorAlertMessageFrom(
  error: Error | ReadonlyArray<GraphQLError>,
  ...args: any[]
): AlertMessage {
  const message = args.length > 0 && isString(args[0]) ? args[0] : undefined;
  const description = args.length > 1 && isString(args[1]) ? args[1] : undefined;
  const onClose =
    args.length > 0 && isFunction(args[0])
      ? args[0]
      : args.length > 1 && isFunction(args[1])
      ? args[1]
      : undefined;
  return newErrorAlertMessage(translateError(error), message, description, onClose);
}

function isString(value: any): value is string {
  return typeof value === "string";
}

function isFunction(value: any): value is Function {
  return typeof value === "function";
}
